import { AnalyzeLoader } from "#modules/quoteRequestLines/AnalyzeLoader";
import { Box } from "#shared/view/components/Box";
import { Flex } from "#shared/view/components/Flex";
import { Thumbnail } from "#shared/view/components/Thumbnails/Thumbnail";

export const AnalyseThumbnail = ({
  size = { width: 55, height: 55 },
}: {
  size?: { width: number | string; height: number | string };
}) => {
  return (
    <Box pos="relative" h={size.height} w={size.width}>
      <Flex
        align={"center"}
        justify={"center"}
        h={"100%"}
        w="100%"
        px={"md"}
        pos="absolute"
        top={0}
        left={0}
      >
        <AnalyzeLoader />
      </Flex>

      <Thumbnail size={size} />
    </Box>
  );
};
